import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    inrestList: [],
};
const getters = {
    getInrest: state => state.inrestList

};

const mutations = {
    INREST_INFO(state, data) {
        state.inrestList = data
    }
};

const actions = {
    getInrest({commit}) {
        axiosGet(`crm/inrest/status`).then((response) => {
            commit('INREST_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
